import {apiGetCall, apiPostCall} from "./index";

export const load   = caretaker => apiGetCall("/messages/get", {caretaker});
export const send   = (caretaker, message, duration, urgent) => apiPostCall("/messages/send", {caretaker, message, duration, urgent});
export const cancel = uuid => apiPostCall("/messages/cancel", {uuid});
